module.exports = __webpack_public_path__ + "static/media/accessory32.19bf38d9.webp";